import { api, API_URL } from "../../config/api"
import { GET_RESTAURANTS_ORDER_FAILURE, GET_RESTAURANTS_ORDER_REQUEST, GET_RESTAURANTS_ORDER_SUCCESS, UPDATE_ORDER_STATUS_FAILURE, UPDATE_ORDER_STATUS_REQUEST, UPDATE_ORDER_STATUS_SUCCESS } from "./ActionType";
export const updateOrderStatus= ({orderId,orderStatus, jwt}) =>{
    return async(dispatch) =>{
        dispatch({type:UPDATE_ORDER_STATUS_REQUEST});

        try{
            const response= await api.put(`/api/admin/order/${orderId}/${orderStatus}`,{
                headers:{
                    Authorization : `Bearer ${jwt} `,
                },
            });
            const updatedOrder=response.data;
            dispatch({type:UPDATE_ORDER_STATUS_SUCCESS,payload: response.data});
            console.log("updated order", updatedOrder);
        }
        catch(error){
            console.log("catch error :",error)
            dispatch({type:UPDATE_ORDER_STATUS_FAILURE, error});
        }
    }
}
export const fetchRestaurantsOrder = ({restaurantId,orderStatus, jwt}) =>{
    return async(dispatch) =>{
        dispatch({type:GET_RESTAURANTS_ORDER_REQUEST});

        try{
            const {data}= await api.get(`/api/admin/order/restaurant/${restaurantId}`,{
                params:{
                    order_satus:orderStatus
                },
                headers:{
                    Authorization : `Bearer ${jwt} `,
                },
            });
            dispatch({type:GET_RESTAURANTS_ORDER_SUCCESS,payload: data});
            console.log("restaurant order", data);
        }
        catch(error){
            console.log("catch error :",error)
            dispatch({type:GET_RESTAURANTS_ORDER_FAILURE, error});
        }
    }
}